import { render } from "./CsvToJson.vue?vue&type=template&id=5b20b661&scoped=true"
import script from "./CsvToJson.vue?vue&type=script&lang=js"
export * from "./CsvToJson.vue?vue&type=script&lang=js"

import "./CsvToJson.vue?vue&type=style&index=0&id=5b20b661&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b20b661"]])

export default __exports__